<template>
    <div style="width: 100%;height: 100%" class="gmv">
        <div class="today">
            当日GMV：¥<span>{{ gmv_today.toFixed(2) }}</span>元
        </div>
        <div class="max">
            历史最高单日GMV：¥<span>{{ gmv_max }}</span>元
        </div>
        <div style="width: 100%;height: calc(100% - 1rem)">
            <ChartItem ref="chart"></ChartItem>
        </div>
    </div>
</template>

<script>
import ChartItem from "@/components/chart-item";


export default {
	name: "volume-statistics",
	components: {ChartItem},

	data() {
		const width = document.body.clientWidth
		let is_w = width / 1920;is_w=is_w>1?1:is_w
		return {
			el: null,
			gmv_today: 0,
			gmv_max: 0,
			config: {
				grid: {

					bottom: 20,
				},
				series: [
					{
						type: 'gauge',
						data: [{name: 'itemA', value: 55, gradient: ['rgba(247,191,80,0.8)', '#e4ac3e']}],
						axisLabel: {
							formatter: '{value}%'
						},
						arcLineWidth: 14,
						backgroundArc: {
							style: {
								stroke: 'rgba(255,255,255,0.06)',
								lineWidth: is_w* 14
							}
						},
						axisTick: {
							style: {
								stroke: '#e4ac3e',
								lineWidth: 1
							}
						},
						pointer: {
							icon: 'rect',
							style: {
								stroke: '#e4ac3e',
								fill: '#e4ac3e',
								lineWidth: is_w* 6
							}
						},
						center: ['50%', '58%'],
						radius: '100%',
						details: {
							show: true,
							offset: [0, is_w*40],
							formatter: '{value}%',
							style: {
								fontSize: is_w* 24,
								fontWeight: 'bold',
								textAlign: 'center',
								textBaseline: 'middle',
								stroke: '#fff',
								fill: '#fff',
							}
						},
						splitNum: 20,
						animationCurve: 'easeOutBack'
					}
				]
			}
		}
	},
	methods: {
		setConfig({gmv_today = 0, gmv_max = Infinity}) {
			this.gmv_today = gmv_today
			this.gmv_max = gmv_max
			this.config.series[0].data[0].value = Math.ceil(gmv_today / gmv_max * 100)

			if (this.el) {
				this.el.setConfig(this.config)
			} else {
				this.el = this.$refs.chart
				this.el.setConfig(this.config)
			}
		}

	},
	mounted() {

	}
}
</script>

<style scoped lang="less">
.gmv {
  position: relative;
  background: url("../assets/images/gmv-bg.png") no-repeat;
  background-size: 100% 100%;
  z-index: 999;
}

.today {
  position: relative;
  color: #e4ac3e;
  font-size: .36rem;
  left: 0.6rem;

  span {
    font-size: .64rem;
    font-style: italic;
  }
}

.max {
  position: relative;
  color: #cdcac3;
  font-size: .36rem;
  left: 0.6rem;
}


</style>
